<template>
  <div class="sub-set">
    <div class="sub">
      <el-select v-model="value" :disabled="step>1" @change="subSiteChange" class="sub-select" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.subSiteId"
          :label="item.subSiteName"
          :value="item.subSiteId">
        </el-option>
      </el-select>
      <router-link :to="{name:'substationSet', query:{sid:-1}}" v-if="!value">
        <el-button type="primary" :disabled="step>1">添加新子站</el-button>
      </router-link>
      <div class="mind" v-if="!value">请选择子站或添加新子站！</div>
      <div v-else>
        <div class="set-step white-box">
          <ul class="xmly-step">
            <li :class="`item step1 ${step>=1 && 'on'}`"><span class="dot"></span>设置显示模块</li>
            <li :class="`item step2 ${step>=2 && 'on'}`"><span class="dot"></span>配置模块展示内容</li>
            <li :class="`item step3 ${step==3 && 'on'}`"><span class="dot"></span>预览和发布</li>
          </ul>
        </div>
        <div class="set-main" v-if="step===1">
          <div class="home-page-pre">
            <div class="title">首页预览</div>
            <iframe class="homePreview" name="homePreview"
                    :src="`${PROTOCOL}${SUB_SITE_HOST}/index/${value>0 ? value:SUB_PREVIEW_ID}?preview=1`"></iframe>
          </div>
          <div class="show-component">
            <div class="title">展示组件</div>
            <div class="components-choose">
              <p>手机端只展示开启状态的组件</p>
              <div v-for="(item,index) in componentsChoose" class="components-radios">
                <span>{{item.txt}}</span>
                <el-radio-group @change="homeSendMessage(item.key, componentsChoose[index].value)"
                                v-model="componentsChoose[index].value">
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
        <div class="set-main" v-else-if="step===2">
          <div class="carousel" v-if="componentsChoose[0].value">
            <div class="title">轮播图片</div>
            <div class="add column-content">
              <el-button type="primary" @click="chooseFile" :loading="addPicLoading">添加图片</el-button>
              <input class="file-upload" type="file" @change="submitFile"/>
              <span>最多添加5张广告图片（图片尺寸：750x330）</span>
            </div>
            <el-table :data="carousels" style="width: 100%" row-class-name="carousel-table-tr">
              <el-table-column type="index" label="序号" width="82"></el-table-column>
              <el-table-column prop="picture" label="图片" width="188">
                <template slot-scope="scope">
                  <div class="column-content carousel-img">
                    <img class="img" :src="scope.row.imgUrl"/>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="链接地址" width="276">
                <template slot-scope="scope">
                  <div>
                    <el-select class="carousel-select-address" v-model="scope.row.contentType" placeholder="请选择"
                               @change="changeContentType">
                      <el-option
                        v-for="item in urlAddress"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="add-address">
                    <span
                      v-show="!!(scope.row.contentType==3 ? scope.row.contentUrl : (scope.row.contentType==2 ? scope.row.contentColumnName : scope.row.contentVoiceName))"
                      class="address-input">{{scope.row.contentType == 3 ? scope.row.contentUrl : (scope.row.contentType == 2 ? scope.row.contentColumnName : scope.row.contentVoiceName)}}</span>
                    <el-button class="carousel-select-column" v-if="scope.row.contentType==2"
                               @click="addContentVisible = true;carouselContentIndex=scope.$index;changeContentType(2);">
                      {{scope.row.contentColumnName ? '更改' : '选择专辑'}}
                    </el-button>
                    <el-button class="carousel-select-voice" v-if="scope.row.contentType==1"
                               @click="addContentVisible = true;carouselContentIndex=scope.$index;changeContentType(1);">
                      {{scope.row.contentVoiceName ? '更改' : '选择声音'}}
                    </el-button>
                    <el-button class="carousel-select-address" v-if="scope.row.contentType==3"
                               @click="inputAddress(scope.$index)">{{scope.row.contentUrl ? '更改' : '输入地址'}}
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="198">
                <template slot-scope="scope">
                  <div class="move-operate">
                    <span class="orange" v-if="scope.$index>0"
                          @click="carChangePos(carousels,scope.$index, -1)">上移</span>
                    <span class="orange" v-if="scope.$index<carousels.length-1"
                          @click="carChangePos(carousels,scope.$index, 1)">下移</span>
                    <span class="orange" @click="carChangePos(carousels,scope.$index, 0)">删除</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="classify-set" v-if="componentsChoose[2].value">
            <div class="title">专栏橱窗设置</div>
            <div>
              <div class="add column-content">
                <el-button type="primary" @click="addClassifyData">添加专栏</el-button>
                <span>最多添加10个专栏</span>
              </div>
              <el-table :data="categorys" style="width: 100%;" row-class-name="classify-table-tr">
                <el-table-column type="index" label="序号" width="97"></el-table-column>
                <el-table-column prop="classify" label="专栏" width="214">
                  <template slot-scope="scope">
                    <el-select class="classify-select" v-model="scope.row.categoryId" placeholder="请选择" @change="switchCategory(scope.row.categoryId, scope.row.subSiteDisplayName)">
                      <el-option
                        v-for="item in classifySelect"
                        :key="item.categoryId"
                        :label="item.category"
                        :value="item.categoryId">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="专栏显示名称（最多四个字）" width="194">
                  <template slot-scope="scope">
                    <el-input :maxlength="4" class="sub-show-name" v-model="scope.row.subSiteDisplayName"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="239">
                  <template slot-scope="scope">
                    <div class="move-operate">
                      <span class="orange" v-if="scope.$index>0"
                            @click="carChangePos(categorys,scope.$index, -1)">上移</span>
                      <span class="orange" v-if="scope.$index<categorys.length-1"
                            @click="carChangePos(categorys,scope.$index, 1)">下移</span>
                      <span class="orange" @click="carChangePos(categorys,scope.$index, 0)">删除</span>
                      <span class="orange cateManage" @click="specialManage" :data-id="scope.row.id" :data-cateId="scope.row.categoryId" :data-name="scope.row.subSiteDisplayName" :data-order="scope.row.serialNumber">专栏管理</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div :class="'set-main'+' '+ (value<=0?'NoneOnline':'')" v-else>
          <div class="online-page-pre" v-if="value>0">
            <div class="title">线上</div>
            <iframe class="onlinePreview" name="onlinePreview"
                    :src="`${PROTOCOL}${SUB_SITE_HOST}/index/${value>0 ? value:SUB_PREVIEW_ID}?preview=1`"></iframe>
          </div>
          <div class="current-page-pre">
            <div class="title">当前</div>
            <iframe class="currPreview" name="currPreview"
                    :src="`${PROTOCOL}${SUB_SITE_HOST}/index/${value>0 ? value:SUB_PREVIEW_ID}?preview=1`"></iframe>
          </div>
        </div>
        <div class="set-main column-content add-sub-name white-box" v-if="step==3">
          <span class="span-14">子站名称</span>
          <el-input class="subStation-name" v-model="subSiteName"></el-input>
        </div>

        <div class="set-main bottom-operate column-content">
          <el-button class="quit-set" @click="quit">退出设置</el-button>
          <el-button type="primary" v-show="step>=2" @click="changeStep(-1)">上一步</el-button>
          <el-button type="primary" v-show="step<3" @click="changeStep(1)">下一步</el-button>
          <el-button type="primary" v-show="step==3" :loading="submitLoading" @click="submit">发布</el-button>
        </div>
      </div>
    </div>

    <el-dialog
      custom-class="el-dialog-album-stick"
      :visible.sync="categoryAlbumVisible"
      top="5%"
      @close="albumStickReset"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-transfer
        :titles="['专辑库','首页专栏显示专辑']"
        v-model="userAlbumIdList"
        :data="searchAlbumList"
        :props="{ key: 'contentId', label: 'contentName' }"
        :button-texts="['删除', '添加']"
        filterable
        :footer-format="{
          noChecked: '${total} / 6',
          hasChecked: '已选 ${checked} 项'
        }"
        v-loading.lock="searching"
        @change="upUserAlbumList"
        :render-content="transferRender"
      ></el-transfer>
      <el-row type="flex" justify="center">
        <el-button type="primary" @click="saveCategory">保存设置</el-button>
      </el-row>
    </el-dialog>


    <el-dialog title="添加内容" :visible.sync="addContentVisible" size="add-content">
      <div class="add-content-header">
        <span class="title">关键字</span>
        <el-form :model="addContentForm" class="" onsubmit="return false;">
          <el-form-item>
            <el-input placeholder="请输入关键字" v-model="addContentForm.searchKeyword"
                      @keyup.enter.native="addContent"></el-input>
          </el-form-item>
          <el-button type="primary" @click="addContent" :loading="addContentSearchLoading">搜索</el-button>
        </el-form>
      </div>
      <div class="show_result">
        <el-radio-group v-model="radioValue">
          <el-radio v-for="radio in contentResult.list" :label="radio.contentId" class="classify-radio column-content" :key="radio.contentId">
            <span class="column-content">
              <img class="column-img" :src="radio.contentCover"/>
              <span :title="radio.contentName" class="column-name">{{radio.contentName}}</span>
              <!-- <span class="column-icon">图文</span> -->
            </span>
          </el-radio>
        </el-radio-group>
        <div v-if="contentResult.list && contentResult.list.length===0">暂无搜索到匹配内容</div>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="addContentForm.curPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="addContentForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="contentResult.totalRecords">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="chooseContent">确 定</el-button>
        <el-button @click="addContentVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {originAddParam, isUrl} from 'utils';
  import Sortable from 'sortablejs'
  import {
    subsiteSelectList,
    fileUpload,
    addContentSub,
    partnerCategoryList,
    subsiteConf,
    createUpdateSubsite,
    userAlbumStick,
    initAlbumList,
    albumSearch
  } from 'api';
  import Cookies from 'js-cookie';

  export default {
    name: 'subSet',
    data() {
      return {
        componentsChoose: [
          {
            txt: "轮播图片",
            value: 1,
            key: 'carouseOn' //此key是给iframe发消息用
          }, {
            txt: "分类导航",
            value: 1,
            key: 'tabOn'
          }, {
            txt: "专栏橱窗",
            value: 1,
            key: 'categoryListOn'
          },
        ],
        submitLoading: false,
        addContentSearchLoading: false,
        addPicLoading: false,
        onlinePageUrl: "",
        addContentForm: {
          "searchType": 1,    //搜索内容的类型 1-声音， 2-专辑
          "searchKeyword": "",//搜索关键字
          "curPage": 1,       //页号
          "pageSize": 10      //每页大小
        },
        //iframe is load
        homePreviewWindowBool: false,
        currPreviewWindowBool: false,
        addContentVisible: false,
        carouselContentIndex: 0, //添加多图时候
        radioValue: '',
        fixed: true,
        step: 1,
        activeName: 'first',
        options: [],
        value: this.$route.query.sid || '',//子站id
        subSiteName: '',//子站名称
        //轮播图片数据
        carousels: [],
        urlAddress: [
          {
            value: 1,
            label: '声音'
          },
          {
            value: 2,
            label: '专辑'
          },
          {
            value: 3,
            label: '自定义链接'
          },
        ],
        classifySelect: [],
        //分类设置数据
        categorys: [],
        //添加内容的搜索数据
        contentResult: {},
        // 专栏置顶专辑
        categoryAlbumVisible: false,
        categoryAlbumInfo: {},
        curCategoryId: '',
        curSubSiteCategoryId: '',
        curSubSiteCategoryName: '',
        userAlbumList: [],
        userAlbumIdList: [],
        searchAlbumList: [],
        initAlbumList: [],
        searching: false,
        cateChanging: '',
        cateChangeEnd: 0
      }
    },
    computed: {
      ...mapGetters([
        'uid',
        'FILE_UPLOAD_PATH',
        'SUB_SITE_HOST',
        'SUB_PREVIEW_ID',
        'FILE_UPLOAD_TOEKN',
        'PROTOCOL'
      ])
    },
    beforeRouteUpdate(to, from, next) {
      this.removeMessageEvent();
      next()
    },
    beforeRouteLeave(to, from, next) {
      this.removeMessageEvent();
      next()
    },
    created() {
      let vis = this;
      subsiteSelectList().then(res => {
        if (parseInt(res.ret) === 0) {
          const data = res.data;
          vis.options = data || [];
          const query = vis.$route.query;
          const sid = query.sid;
          if (+sid && +sid > 0) {
            subsiteConf({subSiteId: sid}).then(res => {
              if (parseInt(res.ret) === 0) {
                const data = res.data;
                vis.value = data.subSiteId;
                vis.subSiteName = data.subSiteName;
                vis.componentsChoose[0].value = data.isCarouselOpen;
                vis.componentsChoose[1].value = data.isTabOpen;
                vis.componentsChoose[2].value = data.isCategoryListOpen;
                vis.carousels = data.carousels;
                ////
                data.categorys.forEach(item => {
                  vis.getUserAlbumList({subSiteId: vis.value, subSiteCategoryId: item.id})
                  .then(res => {
                    if(res.ret === 0){
                      let tmpIds = [], tmps = [];
                      for (var i = 0; i < res.data.list.length; i++) {
                        tmpIds[i] = res.data.list[i].contentId
                        tmps[i] = res.data.list[i]
                      }
                      item['albumIds'] = tmpIds
                      item['albums'] = tmps
                      vis.categoryAlbumInfo[`cateData_${item.subSiteDisplayName}`] = {};
                      vis.categoryAlbumInfo[`cateData_${item.subSiteDisplayName}`]['albums'] = tmps;
                      vis.categoryAlbumInfo[`cateData_${item.subSiteDisplayName}`]['albumIds'] = tmpIds;
                    }
                  })
                  delete item.contentList
                })
                vis.categorys = data.categorys

              }
            }).catch(() => {
            })
          } else if (parseInt(sid) === -1) {
            vis.options.push({
              "subSiteId": -1, "subSiteName": `子站${vis.options.length + 1}`, "subSiteUrl": null, "subSiteQRCode": null
            });
            vis.value = -1
          }

        }
      }).catch(() => {
      });
      partnerCategoryList().then(res => {
        if (parseInt(res.ret) === 0) {
          vis.classifySelect = res.data
        }
      }).catch(() => {
      });
      vis.homePreviewReadyEvent = function (event) {
        // console.log(event);
        vis.homePreviewWindowBool = true;
      };
      window.addEventListener('message', vis.homePreviewReadyEvent, false);
    },
    mounted() {

    },
    methods: {
      submitFile() {
        let vis = this;
        let file = document.getElementsByClassName('file-upload')[0].files[0];
        let temp = {
          fileSize: file.size,
          token: encodeURIComponent(Cookies.get(vis.FILE_UPLOAD_TOEKN)),
          // token: encodeURIComponent(Cookies.get(vis.FILE_UPLOAD_TOEKN)),
          rememberMe: 'y'
        };
        let url = originAddParam(vis.FILE_UPLOAD_PATH, temp);
        let formData = new FormData();
        formData.append('file', file, 'file.png');
        vis.addPicLoading = true;
        fileUpload(url, formData).then(res => {
          vis.addPicLoading = false;
          if (parseInt(res.ret) === 0) {
            const img_url = res.data[0].url;
            vis.carousels.push({
              imgUrl: img_url,
              contentType: '',
              contentId: 0,
              contentVoiceName: '',
              contentColumnName: '',
              contentUrl: ''
            })
          }
        }).catch(() => {
        })
      },
      chooseFile() {
        let vis = this;
        if (vis.carousels.length < 5) {
          let eleFile = document.getElementsByClassName('file-upload')[0];
          eleFile.click()
        } else {
          vis.$message({
            message: '最多添加5张广告图片',
            type: 'warning'
          })
        }
      },
      changeStep(number) {
        let vis = this;
        //操作是否符合规范验证
        if (number === 1 && vis.step === 1) {
          let closeCount = 0;
          vis.componentsChoose.forEach(item => {
            !item['value'] && closeCount++
          });
          if (closeCount === 3) {
            vis.$message({
              type: 'warning',
              message: '至少开启一个组件！'
            });
            return
          }
        } else if (number === 1 && vis.step === 2) { //第二步空值校验
          const componentsChoose = vis.componentsChoose;
          const carousels = vis.carousels;
          const categorys = vis.categorys;
          let isHalt = false;
          for (let i = 0, len = componentsChoose.length; i < len; i++) {
            if (isHalt) {
              break
            }
            const item = componentsChoose[i];
            if (item['key'] === 'carouseOn' && item.value === 1) {
              if (!carousels.length) {
                vis.$message({
                  message: '轮播图片不能为空',
                  type: 'warning'
                });
                isHalt = true;
                break
              }
              for (let i = 0, len = carousels.length; i < len; i++) {
                const item = carousels[i];

                if (!item.contentType || ((parseInt(item.contentType) === 1 || parseInt(item.contentType) === 2) && !item.contentId) || (parseInt(item.contentType) === 3 && !item.contentUrl)) {
                  vis.$message({
                    message: '轮播图片的链接地址不能为空',
                    type: 'warning'
                  });
                  isHalt = true;
                  break
                }
              }
            } else if (item['key'] === 'categoryListOn' && item.value === 1) {
              if (!categorys.length) {
                vis.$message({
                  message: '专栏不能为空',
                  type: 'warning'
                });
                isHalt = true;
                break
              }
              for (let i = 0, len = categorys.length; i < len; i++) {
                const item = categorys[i];
                if (!item.categoryId) {
                  vis.$message({
                    message: '专栏选项不能为空',
                    type: 'warning'
                  });
                  isHalt = true;
                  break
                } else if (!item.subSiteDisplayName) {
                  vis.$message({
                    message: '专栏显示名称不能为空',
                    type: 'warning'
                  });
                  isHalt = true;
                  break
                } else if (!item.albumIds.length && !item.contentCount) {
                  vis.$message({
                    message: `${item.subSiteDisplayName}专栏未设置首页显示专辑，请设置后再点击下一步。`,
                    type: 'warning'
                  });
                  isHalt = true;
                  break
                }

              }
              if(vis.checkSameName()) isHalt = true;
            }
          }
          if (isHalt) {
            return
          }
        }

        // 先让iframe加载，v-if 是 没有这个节点
        // console.log('change-step');
        vis.removeMessageEvent();
        this.step = this.step + number;
        if (number === -1 && vis.step === 1) {
          window.addEventListener('message', vis.homePreviewReadyEvent, false)
        } else if (parseInt(number) === 1 && parseInt(vis.step) === 3) {
          let temp = {
            tabs: [{name: '畅销'}, {name: '新品'}, {name: '分类'}, {name: '已购'}],
            promotorId: vis.uid,
            name: vis.subSiteName,
            id: vis.value
          };
          const keyArr = ['carouseOn', 'tabOn', 'categoryListOn'];
          vis.componentsChoose.forEach((item, index) => {
            temp[keyArr[index]] = item.value
          });

          let carouselsTemp = JSON.parse(JSON.stringify(vis.carousels));
          let categorysTemp = JSON.parse(JSON.stringify(vis.categorys));
          carouselsTemp = carouselsTemp.map((item, index) => {
            item['orderNum'] = index + 1;
            for (let i in item) {
              if (i === 'contentColumnName' || i === 'contentVoiceName') {
                delete item[i];
              } else if (i === 'contentUrl') {
                item['linkUrl'] = item[i];
                delete item[i];
              } else if (i === 'imgUrl') {
                item['coverUrl'] = item[i];
                item['coverUrlLarger'] = item[i];
                item['coverUrlMiddle'] = item[i];
                item['coverUrlSmall'] = item[i];
              }
            }
            return item;
          });
          categorysTemp.map((item, index) => {
            item['orderNum'] = index + 1;
            const categoryId = item['categoryId'];
            const classifySelect = vis.classifySelect;
            for (let i = 0, len = classifySelect.length; i < len; i++) {
              let tp = classifySelect[i];
              if (tp['categoryId'] === categoryId) {
                item['name'] = tp['category'];
                break;
              }
            }

            const itemTemp = JSON.parse(JSON.stringify(item));
            for (let i in itemTemp) {
              if (i === 'contentCount') {
                item['displayQuantiny'] = itemTemp[i];
                delete item[i];
              }else if(i === 'albumIds'){
                item['displayAlbumIds'] = itemTemp[i];
                delete item[i];
              } else if (i === 'subSiteDisplayName') {
                item['displayName'] = itemTemp[i];
                delete item[i];
              } else if (i === 'categoryId') {
                item['id'] = itemTemp[i];
                delete item[i];
              } else if (i === 'category') {
                delete item[i];
              }
            }
            return item;
          });
          temp['carouses'] = carouselsTemp;
          temp['categories'] = categorysTemp;

          vis.currPreviewSendEvent = function (event) {
            if (event.origin !== `${vis.PROTOCOL}${vis.SUB_SITE_HOST}`) return;
            vis.currPreviewWindowBool = true;
            const currPreviewWindow = document.getElementsByClassName('currPreview')[0].contentWindow
            currPreviewWindow.postMessage(temp, event.origin)
          };
          if (vis.currPreviewWindowBool) {
            const currPreviewWindow = document.getElementsByClassName('currPreview')[0].contentWindow
            currPreviewWindow.postMessage(temp, `${vis.PROTOCOL}${vis.SUB_SITE_HOST}`)
          } else {
            //listener
            window.addEventListener('message', vis.currPreviewSendEvent, false)
          }
        }

      },
      carChangePos(data, index, num) {
        let vis = this;
        if (num) {
          vis.cateChanging = 'move';
          vis.cateChangeEnd = 2;
          data.splice(index, 1, ...data.splice(index + num, 1, data[index]))
        } else {
          //删除
          vis.cateChanging = 'del';
          vis.cateChangeEnd = vis.categorys.length - index - 1;
          data.splice(index, 1);
        }
      },
      subSiteChange() {
        const curOption = arguments[0];
        this.$router.push({name: 'substationSet', query: {sid: curOption}})
      },
      inputAddress(index) {
        let vis = this;
        vis.$prompt('请输入链接地址', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({value}) => {
          vis.carousels[index].contentUrl = value;
          vis.clearContent()
        }).catch(() => {
          vis.clearContent()
        });
      },
      clearContent() {
        this.contentResult = {}
      },
      addContent() {
        let vis = this;
        if (vis.addContentVisible) {
          vis.addContentSearchLoading = true;
          addContentSub(vis.addContentForm).then(res => {
            vis.addContentSearchLoading = false;
            if (parseInt(res.ret) === 0) {
              vis.contentResult = res.data
            }
          }).catch(() => {
          })
        }
      },
      changeContentType() {
        this.addContentForm.searchType = arguments[0];
      },
      handleSizeChange() {
        this.addContentForm.pageSize = arguments[0];
        this.addContent()
      },
      handleCurrentChange() {
        this.addContentForm.curPage = arguments[0];
        this.addContent()
      },
      chooseContent() {
        let vis = this;
        vis.addContentVisible = false;
        const is_checked = document.querySelector('.show_result .is-checked');
        vis.carousels[vis.carouselContentIndex].contentId = is_checked.querySelector('input').value;
        const key = parseInt(vis.addContentForm.searchType) === 1 ? 'contentVoiceName' : 'contentColumnName';
        vis.carousels[vis.carouselContentIndex][key] = is_checked.parentNode.querySelector('.column-name').innerHTML;
        //vis.clearContent()
      },
      addClassifyData() {
        let vis = this;
        if (vis.categorys.length < 10) {
          let len = vis.categorys.length + 1;
          vis.categorys.push({
            "albumIds": [],
            "albums": [],
            "category": "",            //分类名(付费精品分类下的标签/热词)，比如商业、新知等
            "categoryId": "",          //喜马拉雅分类的ID
            "subSiteDisplayName": "", //子站上显示的分类名称
            "contentCount": "",        //该分类下显示的条目数量
            "serialNumber": len
          })
        } else {
          vis.$message({
            type: 'warning',
            message: '最多添加10个专栏'
          })
        }

      },
      submit() {
        let vis = this;

        let temp = {
          subSiteId: vis.value,
          subSiteName: vis.subSiteName
        };
        const keyArr = ['isCarouselOpen', 'isTabOpen', 'isCategoryListOpen'];
        vis.componentsChoose.forEach((item, index) => {
          temp[keyArr[index]] = item.value
        });
        let carouselsTemp = JSON.parse(JSON.stringify(vis.carousels));
        let categorysTemp = JSON.parse(JSON.stringify(vis.categorys));
        carouselsTemp = carouselsTemp.map((item, index) => {
          item['serialNumber'] = index + 1;
          for (let i in item) {
            if (i === 'contentColumnName' || i === 'contentVoiceName') {
              delete item[i];
            }
          }
          return item
        });
        categorysTemp.map((item, index) => {
          item['serialNumber'] = index + 1;
          delete item.id
          delete item.albums
          const categoryId = item['categoryId'];
          const classifySelect = vis.classifySelect;

          for (let i = 0, len = classifySelect.length; i < len; i++) {
            let tp = classifySelect[i];
            if (tp['categoryId'] === categoryId) {
              item['category'] = tp['category'];
              return false
            }
          }
          return item
        });
        temp['carousels'] = carouselsTemp;
        temp['categorys'] = categorysTemp;

        //category 为空的
        //去掉 contentColumnName contentVoiceName
        //两者都加上serialNumber = index+1  本来有的就修改
        vis.submitLoading = true;
        createUpdateSubsite(temp).then(res => {
          vis.submitLoading = false;
          if (parseInt(res.ret) === 0) {
            this.$message({
              type: 'success',
              message: '发布成功'
            });
            vis.$router.push({name: "SubManager"})
          }
        }).catch(() => {
          vis.submitLoading = false
        })
      },
      quit() {
        let vis = this;
        this.$confirm('退出设置，编辑的内容将不保存, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          vis.$router.push({name: 'substationSet'})
        }).catch(() => {
        });
      },
      homeSendMessage(key, value) {
        let vis = this;
        if (vis.homePreviewWindowBool) {
          let temp = {};
          if (key) {
            temp[key] = value
          } else {
            vis.componentsChoose.forEach(item => {
              temp[item.key] = item.value;
            })
          }
          const homePreviewWindow = document.getElementsByClassName('homePreview')[0].contentWindow;
          console.log(temp)
          homePreviewWindow.postMessage(temp, "*")
        } else {
          console.log('homeBool:false')
        }
      },
      //
      removeMessageEvent() {
        // console.log('removeEvent');
        let vis = this;
        vis.homePreviewWindowBool = false;
        vis.currPreviewWindowBool = false;
        window.removeEventListener('message', vis.homePreviewReadyEvent, false);
        //window.removeEventListener('message', vis.homePreviewEvent, false);
        window.removeEventListener('message', vis.currPreviewSendEvent, false);
      },
      getUserAlbumList(params) {
        let vis = this;
        let { subSiteCategoryId, subSiteCategoryName, subSiteId } = params;
        if(!subSiteCategoryName){
          delete params.subSiteCategoryName
          return userAlbumStick(params)
        }else if(vis.categoryAlbumInfo[`cateData_${subSiteCategoryName}`]){
          return {
            data: {
              list: vis.categoryAlbumInfo[`cateData_${subSiteCategoryName}`].albums
            }
          }
        }else{
          return {
            data: {
              list: []
            }
          }
        }
      },
      switchCategory(id, name) {
        let vis = this;
        let len = vis.categorys.length;
        if(vis.cateChanging === 'move' || vis.cateChanging === 'del'){
          if(vis.cateChangeEnd === 1) vis.cateChanging = '';
          vis.cateChangeEnd--;
        }else if(name){
          vis.categorys.forEach(item => {
            if(item.subSiteDisplayName === name){
              item.albums = [];
              item.albumIds = [];
            }
          })
          vis.categoryAlbumInfo[`cateData_${name}`].albums = [];
          vis.categoryAlbumInfo[`cateData_${name}`].albumIds = [];
        }
      },
      upUserAlbumList() {
        let vis = this;
        let curLen = arguments[0].length;
        if(curLen > 6) {
          // prevent
          vis.userAlbumIdList = vis.userAlbumIdList.filter(item => {
            let notExist = arguments[2].indexOf(item) === -1;
            return notExist
          })
          vis.$message({
            message: '最多设置6个首页专栏显示专辑，请删除不需要的专辑。',
            type: 'warning'
          });
        }else{
          vis.userAlbumList = vis.searchAlbumList.filter(item => {
            let isExist = arguments[0].indexOf(item.contentId) !== -1;
            if(isExist){ return item }else{ return false }
          })
          vis.$nextTick(() => vis.delDrag());
        }
      },
      delDrag() {
        let oRmDrags = document.querySelectorAll('.el-transfer-panel:first-child .transfer-item-drag');
        for (var i = 0; i < oRmDrags.length; i++) { oRmDrags[i].remove() }
      },
      albumSearch(searchKeyword) {
        let vis = this;
        if(!searchKeyword){
          vis.$message({
            message: '请输入任意名称或id',
            type: 'warning'
          })
          return false;
        }
        vis.searching = true;
        let searchType = 2;
        let params = { searchKeyword, categoryId: vis.curCategoryId, searchType }
        albumSearch(params).then(res => {
          if(res.ret === 0){
            vis.searchAlbumList = res.data.list;
            vis.userAlbumList.forEach(item => {
              let isExist = false;
              for (var i = 0; i < vis.searchAlbumList.length; i++) {
                isExist = item.contentId === vis.searchAlbumList[i].contentId;
                if(isExist) break;
              }
              !isExist && vis.searchAlbumList.push(item);
            })
            vis.$nextTick(() => {
              // dom style
              let oUserAlbumList = document.querySelectorAll('.el-dialog-album-stick .el-transfer-panel__list');
              oUserAlbumList[1].style.height = '346px';
              let oSearchIcon = document.querySelector('.el-dialog-album-stick .el-transfer-panel__filter .el-input__icon');
              oSearchIcon.classList.remove('el-icon-search')
              oSearchIcon.classList.add('el-icon-circle-close')
              let oClearIcon = document.querySelector('.el-dialog-album-stick .el-transfer-panel__filter .el-icon-circle-close');
              oClearIcon.onclick = e => {
                let oTarget = e.target;
                oTarget.nextSibling.value = '';
                oTarget.classList.remove('el-icon-circle-close');
                oTarget.classList.add('el-icon-search');
                oTarget.onclick = () => vis.albumSearch(oTarget.nextSibling.value)
                // 还原总列表
                vis.searchAlbumList = vis.initAlbumList;
                // 用户选项
                vis.userAlbumList.forEach(m => {
                  let isExist = vis.searchAlbumList.some(n => { return m.contentId == n.contentId });
                  !isExist && vis.searchAlbumList.push(m)
                })
                vis.$nextTick(() => vis.delDrag());
              }
              vis.delDrag()
            })

            vis.searching = false;
          }else{
            vis.searching = false;
            console.log(res.message)
          }
        })
      },
      albumStickReset() {
        let vis = this;
        vis.searching = false;
        vis.userAlbumList = [];
        vis.userAlbumIdList = [];
        vis.searchAlbumList = [];
        vis.initAlbumList = [];
      },
      saveCategory() {
        let vis = this;
        let { userAlbumList, userAlbumIdList } = vis;
        vis.categoryAlbumInfo[`cateData_${vis.curSubSiteCategoryName}`] = { albums: userAlbumList, albumIds: userAlbumIdList }

        // add albumIds
        vis.categorys.forEach(item => {
          if(item.subSiteDisplayName === vis.curSubSiteCategoryName){
            let cateAlbumInfo = vis.categoryAlbumInfo[`cateData_${vis.curSubSiteCategoryName}`];
            item['albumIds'] = (cateAlbumInfo && cateAlbumInfo.albumIds) || [];
            item['albums'] = (cateAlbumInfo && cateAlbumInfo.albums) || [];
          }
        })

        vis.$message({
          message: '配置成功',
          type: 'success',
          duration: 1500,
          onClose: function () {
            vis.categoryAlbumVisible = false;
            vis.albumStickReset()
          }
        })
      },
      checkSameName() {
        let vis = this;
        let hasSame = false;
        for (var i = 0; i < vis.categorys.length; i++) {
          for (var j = 0; j < vis.categorys.length; j++) {
            if(vis.categorys[i].subSiteDisplayName && vis.categorys[j].subSiteDisplayName && vis.categorys[i].subSiteDisplayName === vis.categorys[j].subSiteDisplayName && i !== j){
              vis.$message({
                message: '请勿输入重复名称',
                type: 'warning'
              })
              hasSame = true;
              break;
            }
          }
        }
        return hasSame;
      },
      specialManage(e) {
        let vis = this;
        let { id, cateid, name, order } = e.target.dataset;
        if(!cateid){
          vis.$message({
            message: '请选择专栏类别',
            type: 'warning'
          })
          return false;
        }else if(!name){
          vis.$message({
            message: '专栏显示名称不能为空',
            type: 'warning'
          })
          return false;
        }
        if(vis.checkSameName()) return false;
        vis.curCategoryId = cateid - 0;
        vis.curSubSiteCategoryId = id - 0;
        vis.curSubSiteCategoryName = name;
        Promise.all([
          vis.getUserAlbumList({
            subSiteId: vis.value,
            subSiteCategoryId: vis.curSubSiteCategoryId,
            subSiteCategoryName: vis.curSubSiteCategoryName
          }),
          initAlbumList({categoryId: cateid, hotWord: ''})
        ]).then(res => {
          vis.userAlbumList = res[0].data.list;
          vis.searchAlbumList = res[1].data.list;
          vis.userAlbumList.forEach(m => {
            let isIdExist = vis.userAlbumIdList.some(o => { return o === m.contentId })
            !isIdExist && vis.userAlbumIdList.push(m.contentId);
            let isExist = vis.searchAlbumList.some(n => { return m.contentId === n.contentId })
            !isExist && vis.searchAlbumList.push(m)
          })
          // vis.categorys.forEach(item => {
          //   if(item.subSiteDisplayName === vis.curSubSiteCategoryName){
          //     item.albumIds = [...vis.userAlbumIdList];
          //     item.albums = [...vis.userAlbumList];
          //   }
          // })
          // console.log(vis.categorys);
          vis.initAlbumList = vis.searchAlbumList;

          vis.$nextTick(() => {
            let oBody = document.querySelectorAll('.el-transfer-panel__body');
            let oFooter = document.querySelector('.el-transfer-panel:first-child .el-transfer-panel__footer');
            oFooter && oFooter.remove();
            let oFilter = document.querySelectorAll('.el-dialog-album-stick .el-transfer-panel__filter');
            oFilter.length > 1 && oFilter[1].remove();
            let oUserAlbumList = document.querySelectorAll('.el-dialog-album-stick .el-transfer-panel__list');
            oUserAlbumList[1].style.height = '346px';
            // sort
            if(vis.userAlbumIdList.length){
              for (var i = 0; i < oUserAlbumList[1].children.length; i++) {
                let itemId = oUserAlbumList[1].children[i].lastChild.children[0].dataset.id - 0;
                let newIdx = vis.userAlbumIdList.indexOf(itemId);
                if(newIdx != i){
                  oUserAlbumList[1].insertBefore(oUserAlbumList[1].children[i], oUserAlbumList[1].children[newIdx])
                }
              }
            }
            // del
            vis.$nextTick(() => vis.delDrag());

            // search
            let cFilter = document.createElement('div');
            cFilter.className = 'el-transfer-panel__filter el-input el-input--small'
            cFilter.innerHTML = '<i class="el-input__icon el-icon-search"></i><input autocomplete="off" placeholder="请输入搜索内容" size="small" icon="search" type="text" class="el-input__inner">'
            oBody[0].insertBefore(cFilter, oFilter[0]);
            oFilter[0].remove();

            let oIcon = cFilter.firstChild;
            let oInput = cFilter.lastChild;
            oIcon.onclick = () => vis.albumSearch(oInput.value);
            oInput.onkeyup = e => e.key === 'Enter' && vis.albumSearch(oInput.value);

            // drag
            let oDragBox = document.querySelector('.el-transfer-panel:last-child .el-transfer-panel__list');
            oDragBox && Sortable.create(oDragBox, {
              handle: '.transfer-item-drag',
              animation: 100,
              // Called by any change to the list (add / update / remove)
              onSort: function (e) {
                let { target, oldIndex ,newIndex } = e;
                let tmpIdArr = [];
                let tmpArr = [];
                for (var i = 0; i < target.children.length; i++) {
                  let itemId = target.children[i].lastChild.children[0].dataset.id - 0;
                  tmpIdArr[i] = itemId;
                  for (var j = 0; j < vis.userAlbumList.length; j++) {
                    if(itemId === vis.userAlbumList[j].contentId){
                      tmpArr[i] = vis.userAlbumList[j];
                    }
                  }
                }
                vis.userAlbumIdList = tmpIdArr;
                vis.userAlbumList = tmpArr;
              }
            })
          });

          vis.categoryAlbumVisible = true;
        })
      },
      transferRender(h, option) {
        return (
          <div class="transfer-list-item" data-id={option.contentId}>
            <a href={'http://www.ximalaya.com/album/'+option.contentId+'/'} target="_blank">{ option.contentName }</a>
            <div class="transfer-item-drag">
              <i class="el-icon-caret-top"></i>
              <i class="el-icon-caret-bottom"></i>
            </div>
          </div>
        );
      }
    },
    watch: {
      addContentVisible: function () {
        let vis = this;
        if (vis.addContentVisible) {
          vis.clearContent()
        }
      },
      categorys: {
        handler: function (now, old) {
          let vis = this;
          vis.categoryAlbumInfo = {};
          now.forEach(item => {
            // console.log(item)
            vis.categoryAlbumInfo[`cateData_${item.subSiteDisplayName}`] = {};
            vis.categoryAlbumInfo[`cateData_${item.subSiteDisplayName}`]['albums'] = item.albums;
            vis.categoryAlbumInfo[`cateData_${item.subSiteDisplayName}`]['albumIds'] = item.albumIds;
          })
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sub {
    & > div {
      width: 745px;
    }
    .mind {
      color: #666;
      line-height: 60px;
    }
    .set-step {
      padding-top: 14px;
      margin-top: 10px;
      height: 110px;
      .xmly-step {
        overflow: hidden;
        padding-top: 50px;
      }
      .xmly-step .item {
        float: left;
        width: 30%;
        text-align: center;
        font-size: 14px;
        color: #999;
        position: relative;
      }
      .xmly-step .item:before {
        position: absolute;
        content: '';
        height: 6px;
        width: 50%;
        background: #e8e8e8;
        top: -25px;
        right: 0;
      }
      .xmly-step .step2 {
        width: 40%;
      }
      .xmly-step .step2:after {
        position: absolute;
        content: '';
        height: 6px;
        width: 50%;
        background: #e8e8e8;
        top: -25px;
        left: 0;
      }
      .xmly-step .item.step3:before {
        left: 0;
        right: auto;
      }
      .xmly-step .dot {
        position: absolute;
        top: -37px;
        margin-left: 14px;
        left: 0;
        right: 0;
        margin: auto;
        width: 30px;
        height: 30px;
        background: #e8e8e8;
        border-radius: 50%;
      }

      .xmly-step .item.on {
        color: #fc5832;
      }
      .xmly-step .item.on .dot {
        background: #fc5832;
      }
      .xmly-step .item.on:before, .xmly-step .item.on:after {
        background: #fc5832;
      }
    }
  }

  .set-main {
    margin-top: 10px;
    overflow: hidden;
    padding: 20px 0;
    & > div {
      background-color: #fff;
    }
    /* .title{
      height: 60px;
      line-height: 60px;
      font-size: 26px;
      padding-left: 20px;
      border-bottom: 1px solid #efefef;
    } */
    .carouselImg {
      width: 120px;
      height: 60px;
    }
    .add {
      padding: 15px 0;
      .el-button {
        margin-left: 20px;
      }
      & > span {
        margin-left: 10px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #999;
      }
    }
    .move-operate {
      & > span {
        cursor: pointer;
      }
      span + span {
        margin-left: 16px;
      }
    }
    .carousel {
      .carousel-img {
        width: 186px;
        img {
          width: 120px;
          height: 60px;
        }
      }
      .add-address {
        margin-top: 10px;
        display: flex;
        .address-input {
          display: inline-block;
          width: 110px;
          height: 35px;
          line-height: 35px;
          border: none;
          margin-right: 18px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

    }
    .classify-set {
      margin-top: 10px;
    }
    &.add-sub-name {
      // height: 60px;
      span {
        margin-left: 20px;
        margin-right: 30px;
      }
    }
  }

  .home-page-pre, .online-page-pre, .current-page-pre {
    float: left;
    width: 49%;
    height: 660px;
    background-color: #fff;
    iframe {
      border: none;
      outline: none;
      width: 320px;
      height: 568px;
      margin-left: 23px;
      margin-top: 15px;
    }
  }

  .online-page-pre .current-page-pre {
    margin-left: 2%;
  }

  .current-page-pre {
    margin-left: 10px;
  }

  .NoneOnline {
    .current-page-pre {
      margin-left: 0px;
      width: 100%;
      iframe {
        margin-left: 212px;
        margin-top: 15px;
      }
    }
  }

  .file-upload {
    display: none;
  }

  .show-component {
    float: left;
    margin-left: 10px;
    background-color: #fff;
    width: 49%;
    height: 660px;
    .components-choose {
      margin-left: 20px;
      margin-top: 20px;
    }
  }

  .bottom-operate {
    padding: 20px 0;
    background-color: #fff;
    margin-bottom: 60px;
    .quit-set {
      margin-left: 270px;
    }
  }

  .el-dialog--add-content {
    .add-content-header {
      height: 77px;
      border-bottom: 1px solid #E8E8E8;
      .title {
        color: #999;
      }
      .el-form-item {
        display: inline-block;
      }
      .el-form {
        display: inline-block;
        margin-left: 5px;
        .el-button {
          margin-left: 40px;
        }
      }

    }
    .classify-radio {
      padding-left: 20px;
      padding-right: 20px;
      border-bottom: 1px solid #E8E8E8;
      height: 80px;
      .column-name {
        margin-left: 10px;
        width: 300px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .column-icon {
        margin-left: 80px;
        width: 44px;
        height: 18px;
        background: #F19E8A;
        border-radius: 2px;
        color: #fff;
        line-height: 18px;
        text-align: center;
      }
    }
    .column-img {
      width: 80px;
      height: 60px;
      margin-left: 15px;
    }
    .el-pagination {
      margin-top: 30px;
    }
  }


</style>





// WEBPACK FOOTER //
// subSet.vue?50c4c6c2